module.exports = __webpack_public_path__ + "static/img/manual_ja_7.b0d4d08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_7.png
// module id = 3EZx
// module chunks = 4